export default __webpack_public_path__ + "static/media/gmail.10d49476.svg";